export function validateFields(schema, values) {
  const errors = {};
  schema.forEach((field) => {
    const value = values[field.name];
    if (field.required) {
      const missing = Array.isArray(value) ? value.length === 0 : !String(value ?? '').trim();
      if (missing) {
        errors[field.name] = field.message || 'This field is required';
        return;
      }
    }

    const shouldValidate =
      field.validate &&
      value != null &&
      !(typeof value === 'string' && value.trim() === '');
    if (shouldValidate) {
      const result = field.validate(value);
      if (result) errors[field.name] = field.message;
    }
  });
  return { errors, isValid: Object.keys(errors).length === 0 };
}
